<div class="time-distribution">
  <div #chartContainer class="chart-container">
    <!-- Loading state -->
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    }

    <!-- Chart content -->
    @if (!isLoading && chartData.length > 0) {
      <div class="chart-wrapper">
        <ngx-charts-pie-chart
          [view]="view"
          [scheme]="colorScheme"
          [results]="chartData"
          [gradient]="gradient"
          [legend]="showLegend"
          [legendPosition]="legendPosition"
          [legendTitle]="legendTitle"
          [labels]="showLabels"
          [doughnut]="isDoughnut"
          [animations]="animations">
        </ngx-charts-pie-chart>
      </div>
    }

    <!-- No data state -->
    @if (!isLoading && chartData.length === 0) {
      <div class="no-data-message">
        <i class="bi bi-inbox fs-2 text-muted"></i>
        <p class="text-muted mt-2">No time distribution data available</p>
      </div>
    }
  </div>
</div>
